module.exports = __webpack_public_path__ + "img/freight_yard5_3.801efffa.png";